// extracted by mini-css-extract-plugin
export var actionIcon = "_sl-0";